import React from "react";

export default function Favorites() {
  return <div style={{ height: "80vh" }}>favorites</div>;
}
